import { configureStore } from '@reduxjs/toolkit'
import accommodationReducer from "./accommodationSlice";

export default configureStore({
  reducer: {
    accommodation: accommodationReducer
  }
})

